export { ItemsDetailComponent } from './detail.component';